<template>
  <div class="user-detail-form">
    <div class="form-header">
      <h3>{{ isEdit ? '用户详情' : '新增用户' }}</h3>
      <a-space>
        <a-button type="primary" @click="handleSave" :loading="saving">
          <a-icon type="save" />保存
        </a-button>
        <a-button v-if="!isEdit" @click="handleCancel">
          <a-icon type="close" />取消
        </a-button>
      </a-space>
    </div>

    <a-form :form="form" layout="vertical" class="edit-user-form">
      <!-- 动态渲染表单字段 -->
      <div v-for="(section, sectionIndex) in formSections" :key="sectionIndex" class="form-section">
        <a-row v-for="(row, rowIndex) in section.rows" :key="`${sectionIndex}-${rowIndex}`" :gutter="16">
          <a-col v-for="(field, fieldIndex) in row" :key="`${sectionIndex}-${rowIndex}-${fieldIndex}`"
            :span="field.span || 24">
            <a-form-item :label="field.label">
              <!-- 输入框 -->
              <a-input v-if="field.type === 'input'" v-decorator="[
                field.name,
                {
                  initialValue: getFieldInitialValue(field.name)
                }
              ]" :placeholder="isEdit ? '' : `请输入${field.label}`" />

              <!-- 密码输入框 -->
              <a-input-password v-else-if="field.type === 'password'" v-decorator="[
                field.name,
                {
                  initialValue: getFieldInitialValue(field.name)
                }
              ]" :placeholder="isEdit ? '' : `请输入${field.label}`" />

              <!-- 单选框组 -->
              <a-radio-group v-else-if="field.type === 'radio'" v-decorator="[
                field.name,
                {
                  initialValue: getFieldInitialValue(field.name, field.defaultValue)
                }
              ]">
                <a-radio v-for="(option, optionIndex) in field.options" :key="optionIndex" :value="option.value">
                  {{ option.label }}
                </a-radio>
              </a-radio-group>

              <!-- 下拉选择框 -->
              <a-select v-else-if="field.type === 'select'" v-decorator="[
                field.name,
                {
                  initialValue: getFieldInitialValue(field.name, field.defaultValue)
                }
              ]" :placeholder="isEdit ? '' : `请选择${field.label}`">
                <a-select-option v-for="(option, optionIndex) in field.options" :key="optionIndex"
                  :value="option.value">
                  {{ option.label }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
      </div>

      <div class="form-actions">
        <a-button type="primary" size="large" @click="handleSave" :loading="saving">
          <a-icon type="save" />保存用户
        </a-button>
      </div>
    </a-form>
  </div>
</template>

<script>
export default {
  name: 'UserDetailForm',
  props: {
    user: {
      type: Object,
      default: () => ({})
    },
    mode: {
      type: String,
      default: 'edit', // 'edit' 或 'add'
      validator: value => ['edit', 'add'].includes(value)
    },
    platform: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      form: this.$form.createForm(this),
      saving: false
    }
  },
  computed: {
    isEdit() {
      return this.mode === 'edit';
    },

    // 根据平台动态生成表单配置
    formSections() {
      // 基础信息部分 - 所有银行通用
      const basicSection = {
        title: '基本信息',
        rows: [

        ]
      };



      // 根据不同银行平台添加特有字段
      let bankSpecificSection = null;

      // 中国银行特有字段
      if (this.platform === 'js') {
        bankSpecificSection = {
          title: '建行',
          rows: [
            [
              {
                label: '户名',
                name: 'name',
                type: 'input'
              },
              {
                label: '卡号',
                name: 'card.card_num',
                type: 'input'
              },
              {
                label: '打印网点',
                name: 'card.print_institution',
                type: 'input'
              },
              {
                label: '编码',
                name: 'card.rand_code',
                type: 'input'
              },
              {
                label: '开始时间',
                name: 'card.start_time',
                type: 'input',
              },
              {
                label: '结束时间',
                name: 'card.end_time',
                type: 'input',
              },
              {
                label: '打印时间',
                name: 'card.print_time',
                type: 'input',
              },
              {
                label: '备注',
                name: 'card.remark',
                type: 'input',
              }
            ]
          ]
        };
      }

      // 农业银行特有字段
      else if (this.platform === 'ny') {
        bankSpecificSection = {
          title: '农业银行',
          rows: [
            [
              {
                label: '户名',
                name: 'name',
                type: 'input'
              },
              {
                label: '账号',
                name: 'card.account',
                type: 'input'
              },
              {
                label: '打印机构',
                name: 'card.print_institution',
                type: 'input'
              },
              {
                label: '打印柜员',
                name: 'card.print_teller',
                type: 'input'
              },
              {
                label: '打印时间',
                name: 'card.print_time',
                type: 'input',
              },
              {
                label: '开始时间',
                name: 'card.start_time',
                type: 'input',
              },
              {
                label: '结束时间',
                name: 'card.end_time',
                type: 'input',
              },
              {
                label: '章编码',
                name: 'card.rand_code',
                type: 'input',
              },
              {
                label: '打印支行',
                name: 'card.print_sub_bank',
                type: 'input',
              },
              {
                label: '备注',
                name: 'card.remark',
                type: 'input',
                span: 24
              }
            ]
          ]
        };
      }

      // 农业银行特有字段
      else if (this.platform === 'nyzz') {
        bankSpecificSection = {
          title: '农业银行',
          rows: [
            [
              {
                label: '户名',
                name: 'name',
                type: 'input'
              },
              {
                label: '账号',
                name: 'card.account',
                type: 'input'
              },
              {
                label: '打印机构',
                name: 'card.print_institution',
                type: 'input'
              },
              {
                label: '打印柜员',
                name: 'card.print_teller',
                type: 'input'
              },
              {
                label: '打印时间',
                name: 'card.print_time',
                type: 'input',
              },
              {
                label: '开始时间',
                name: 'card.start_time',
                type: 'input',
              },
              {
                label: '结束时间',
                name: 'card.end_time',
                type: 'input',
              },
              {
                label: '章编码',
                name: 'card.rand_code',
                type: 'input',
              },
              {
                label: '打印支行',
                name: 'card.print_sub_bank',
                type: 'input',
              },
              {
                label: '备注',
                name: 'card.remark',
                type: 'input',
                span: 24
              }
            ]
          ]
        };
      }

      // 微信特有字段
      else if (this.platform === 'wx') {
        bankSpecificSection = {
          title: '微信',
          rows: [
            [
              {
                label: '姓名',
                name: 'name',
                type: 'input'
              },
              {
                label: '身份证',
                name: 'idcard',
                type: 'input'
              },
              {
                label: '微信号',
                name: 'card.account',
                type: 'input'
              },
              {
                label: '打印流水号',
                name: 'card.print_serial',
                type: 'input'
              },
              {
                label: '开始时间',
                name: 'card.start_time',
                type: 'input',
              },
              {
                label: '结束时间',
                name: 'card.end_time',
                type: 'input',
              },
              {
                label: '备注',
                name: 'card.remark',
                type: 'input',
              }
            ]
          ]
        };
      }

      // 邮政银行特有字段
      else if (this.platform === 'yz') {
        bankSpecificSection = {
          title: '邮政银行',
          rows: [
            [
              {
                label: '户名',
                name: 'name',
                type: 'input'
              },
              {
                label: '身份证',
                name: 'idcard',
                type: 'input'
              },
              {
                label: '卡号',
                name: 'card.card_num',
                type: 'input'
              },
              {
                label: '账号',
                name: 'card.account',
                type: 'input'
              },
              {
                label: '机构名称',
                name: 'card.print_institution',
                type: 'input'
              },
              {
                label: '印章流水',
                name: 'card.print_serial',
                type: 'input'
              },
              {
                label: '章编码',
                name: 'card.rand_code',
                type: 'input'
              },
              {
                label: '打印支行',
                name: 'card.print_sub_bank',
                type: 'input'
              },
              {
                label: '打印时间',
                name: 'card.print_time',
                type: 'input',
              },
              {
                label: '开始时间',
                name: 'card.start_time',
                type: 'input',
              },
              {
                label: '结束时间',
                name: 'card.end_time',
                type: 'input',
              },
              {
                label: '备注',
                name: 'card.remark',
                type: 'input',
              }
            ]
          ]
        };
      }

      // 中国银行特有字段
      else if (this.platform === 'zg') {
        bankSpecificSection = {
          title: '中国银行',
          rows: [
            [
              {
                label: '户名',
                name: 'name',
                type: 'input'
              }
            ],
            [
              {
                label: '卡号',
                name: 'card.card_num',
                type: 'input'
              },
              {
                label: '账号',
                name: 'card.account',
                type: 'input'
              }
            ],
            [
              {
                label: '打印时间',
                name: 'card.print_time',
                type: 'input',
              },
              {
                label: '开始时间',
                name: 'card.start_time',
                type: 'input',
              },
              {
                label: '结束时间',
                name: 'card.end_time',
                type: 'input',
              }
            ],
            [
              {
                label: '打印网点',
                name: 'card.print_institution',
                type: 'input'
              },
              {
                label: '备注',
                name: 'card.remark',
                type: 'input'
              }
            ]
          ]
        };
      }

      // GS银行特有字段
      else if (this.platform === 'gs') {
        bankSpecificSection = {
          title: 'GS银行',
          rows: [
            [
              {
                label: '户名',
                name: 'name',
                type: 'input'
              },
              {
                label: '卡号',
                name: 'card.card_num',
                type: 'input'
              },
              {
                label: '账号',
                name: 'card.account',
                type: 'input'
              },
              {
                label: '支行',
                name: 'card.sub_bank',
                type: 'input'
              },
              {
                label: '印章支行',
                name: 'card.company',
                type: 'input'
              },
              {
                label: '开始时间',
                name: 'card.start_time',
                type: 'input'
              },
              {
                label: '结束时间',
                name: 'card.end_time',
                type: 'input'
              },
              {
                label: '打印时间',
                name: 'card.print_time',
                type: 'input'
              }
            ],
            [
              {
                label: '备注',
                name: 'card.remark',
                type: 'input',
                span: 24
              }
            ]
          ]
        };
      }

      // 平安银行特有字段
      else if (this.platform === 'pa') {
        bankSpecificSection = {
          title: '平安银行',
          rows: [
            [
              {
                label: '户名',
                name: 'name',
                type: 'input'
              },
              {
                label: '卡号',
                name: 'card.card_num',
                type: 'input'
              },
              {
                label: '清单编号',
                name: 'card.pa_no',
                type: 'input'
              },
              {
                label: '开户行',
                name: 'card.print_sub_bank',
                type: 'input'
              },
              {
                label: '受理行',
                name: 'card.print_institution',
                type: 'input'
              },
              {
                label: '开始时间',
                name: 'card.start_time',
                type: 'input'
              },
              {
                label: '结束时间',
                name: 'card.end_time',
                type: 'input'
              },
              {
                label: '打印时间',
                name: 'card.print_time',
                type: 'input'
              },
              {
                label: '章编码',
                name: 'card.rand_code',
                type: 'input'
              }
            ],
            [
              {
                label: '备注',
                name: 'card.remark',
                type: 'input',
                span: 24
              }
            ]
          ]
        };
      }

      // 兴业银行特有字段
      else if (this.platform === 'xy') {
        bankSpecificSection = {
          title: '兴业银行',
          rows: [
            [
              {
                label: '户名',
                name: 'name',
                type: 'input'
              },
              {
                label: '账户账号',
                name: 'card.card_num',
                type: 'input'
              },
              {
                label: '账户类型',
                name: 'card.account',
                type: 'input'
              },
              {
                label: '开户支行',
                name: 'card.sub_bank',
                type: 'input'
              },
              {
                label: '打印机构',
                name: 'card.print_institution',
                type: 'input'
              },
              {
                label: '核验编号',
                name: 'card.print_serial',
                type: 'input'
              },
              {
                label: '章编码',
                name: 'card.rand_code',
                type: 'input'
              },
              {
                label: '开始时间',
                name: 'card.start_time',
                type: 'input'
              },
              {
                label: '结束时间',
                name: 'card.end_time',
                type: 'input'
              },
              {
                label: '打印时间',
                name: 'card.print_time',
                type: 'input'
              }
            ],
            [
              {
                label: '备注',
                name: 'card.remark',
                type: 'input',
                span: 24
              }
            ]
          ]
        };
      }
      else if (this.platform === 'jt') {
        bankSpecificSection = {
          title: '交通银行',
          rows: [
            [
              {
                label: '户名',
                name: 'name',
                type: 'input'
              },
              {
                label: '账号/卡号',
                name: 'card.card_num',
                type: 'input'
              },
              {
                label: '证件号码',
                name: 'card.account',
                type: 'input'
              },
              {
                label: '柜员号',
                name: 'card.print_teller',
                type: 'input'
              },
              {
                label: '受理行',
                name: 'card.print_institution',
                type: 'input'
              },
              {
                label: '章编码',
                name: 'card.rand_code',
                type: 'input'
              },
              {
                label: '查询起日',
                name: 'card.start_time',
                type: 'input'
              },
              {
                label: '查询止日',
                name: 'card.end_time',
                type: 'input'
              },
              {
                label: '打印时间',
                name: 'card.print_time',
                type: 'input'
              }
            ],
            [
              {
                label: '备注',
                name: 'card.remark',
                type: 'input',
                span: 24
              }
            ]
          ]
        };
      }

      // 组合所有部分
      const sections = [];

      // 如果有银行特有字段，只显示银行特有字段
      if (bankSpecificSection) {
        sections.push(bankSpecificSection);
      } else {
        // 否则显示通用字段
        sections.push(basicSection, idCardSection, addressSection, otherSection);
      }

      return sections;
    }
  },
  watch: {
    user(newUser) {
      // 当用户变更时，重置表单
      this.$nextTick(() => {
        this.form.resetFields();
      });
    }
  },
  methods: {
    // 获取字段初始值
    getFieldInitialValue(fieldName, defaultValue) {
      // 处理嵌套字段，如 card.card_num
      if (fieldName.includes('.')) {
        const parts = fieldName.split('.');
        let value = this.user;

        for (const part of parts) {
          if (!value || typeof value !== 'object') {
            return defaultValue;
          }
          value = value[part];
        }

        return value !== undefined ? value : defaultValue;
      }

      // 处理普通字段
      return this.user[fieldName] !== undefined ? this.user[fieldName] : defaultValue;
    },

    // 保存表单
    handleSave() {
      // 不进行表单验证，直接获取表单值
      const values = this.form.getFieldsValue();

      this.saving = true;

      // 初始化简化的数据结构，只包含接口需要的字段
      const formData = {
        platform: this.platform,
        card: {
        }
      };

      // 如果是编辑模式，添加ID
      if (this.isEdit && this.user && this.user.id) {
        formData.id = this.user.id;
      }

      // 设置当前平台的发送邮件标志
      if (this.platform) {
        formData[`${this.platform}_send_email`] = 1;
      }

      // 遍历所有表单配置，填充表单数据
      this.formSections.forEach(section => {
        section.rows.forEach(row => {
          row.forEach(field => {
            // 处理嵌套字段，如 card.account
            if (field.name.includes('.')) {
              const parts = field.name.split('.');
              const mainField = parts[0];
              const subField = parts[1];

              if (!formData[mainField]) {
                formData[mainField] = {};
              }

              // 从表单值中获取嵌套字段的值
              if (values[mainField] && values[mainField][subField] !== undefined) {
                formData[mainField][subField] = values[mainField][subField];
              }
              // 如果表单值中没有，尝试从用户数据中获取
              else if (this.user && this.user[mainField] && this.user[mainField][subField] !== undefined) {
                formData[mainField][subField] = this.user[mainField][subField];
              }
            } else {
              // 处理普通字段
              if (values[field.name] !== undefined) {
                formData[field.name] = values[field.name];
              }
              // 如果表单值中没有，尝试从用户数据中获取
              else if (this.user && this.user[field.name] !== undefined) {
                formData[field.name] = this.user[field.name];
              }
            }
          });
        });
      });

      // 确保card对象包含必要的字段和ID
      if (this.user && this.user.card) {
        // 保留原始card的id和user_id
        if (this.user.card.id) {
          formData.card.id = this.user.card.id;
        }
        if (this.user.card.user_id) {
          formData.card.user_id = this.user.card.user_id;
        }
      }

      // 确保platform字段正确设置
      formData.card.platform = this.platform;

      // 发送保存事件
      this.$emit('save', formData);
    },

    // 取消操作
    handleCancel() {
      this.$emit('cancel');
    },

    // 设置保存状态
    setSaving(value) {
      this.saving = value;
    }
  }
}
</script>

<style scoped>
.user-detail-form {
  background: #fff;
  padding: 16px;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  height: 100%;
  overflow-y: auto;
}

.form-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid #f0f0f0;
}

/* 编辑用户表单样式 */
.edit-user-form {
  padding: 0 8px;
}

.form-section {
  margin-bottom: 24px;
  padding: 16px;
  background-color: #fafafa;
  border-radius: 4px;
  border: 1px solid #f0f0f0;
}

.section-title {
  font-size: 16px;
  font-weight: 500;
  color: #1890ff;
  margin-bottom: 16px;
  padding-bottom: 8px;
  border-bottom: 1px solid #f0f0f0;
}

.form-actions {
  margin-top: 24px;
  text-align: center;
  padding: 16px 0;
  border-top: 1px solid #f0f0f0;
}

/* 响应式布局调整 */
@media (max-width: 768px) {
  .form-section {
    padding: 12px;
  }
}
</style>